export const isPrimitiveType = (value: any): boolean => {
    return (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean');
};
